module.exports = __webpack_public_path__ + "media/src/images/system-logo-fe62d0edb93ca312bdc9561419293040.png";